var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_437_4000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.625,
    width: 17,
    height: 12.75,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_437_4000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.625H0.5V13.375H17.5V0.625Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5078 0.625L9.02656 5.43281L2.57187 0.625H0.5V2.27188L6.875 7.02656L0.5 11.7547V13.375H2.625L9 8.62031L15.3484 13.375H17.5V11.7812L11.1516 7.05313L17.5 2.325V0.625H15.5078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2375 8.08906L0.5 12.3125V13.375L7.69844 8.08906H6.2375ZM11.125 8.62031L10.9656 9.55L16.0656 13.375H17.5L11.125 8.62031ZM0.5 0.625V0.704688L7.11406 5.69844L7.06094 4.52969L1.82812 0.625H0.5ZM17.5 0.625L11.1516 5.3H12.7453L17.5 1.74063V0.625Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0984 0.625V13.375H6.84844V0.625H11.0984ZM17.5 4.875V9.125H0.5V4.875H17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.75156V8.30156H0.5V5.75156H17.5ZM10.2484 0.625V13.375H7.69844V0.625H10.2484Z",
    fill: "#C8102E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEn);
export default __webpack_public_path__ + "static/media/flag_en.7c89dd46d3b5b433b858c6c39eeaf6eb.svg";
export { ForwardRef as ReactComponent };